var render = function render(_c,_vm){return _c('div',{staticClass:"content-loader",class:{ cover: _vm.props.cover !== false }},[_c('div',{staticClass:"content-loader-body"},[_c('b-spinner',{staticClass:"content-loader-spinner",attrs:{"small":"","variant":"secondary"}}),_vm._v(" "+_vm._s(_vm.props.message)+" ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }